import TemplateForm from './TemplateForm';

export default TemplateForm;
